import { RatingStar, RatingStarButton, RatingWrapper } from "./styled";
import { ReactComponent as Star } from "./assets/star.svg";
import { useState } from "react";
import useClickWithAuth from "../../hooks/useClickWithAuth";
import { useRatePodcastMutation } from "../../api/podcastsApi";

const STARS_COUNT = 5;

export const RatingStars = ({ initialRating = 0, podcastId }) => {
  const [rating, setRating] = useState(initialRating);
  const [hoverRating, setHoverRating] = useState(0);
  const handleClickWithAuth = useClickWithAuth();

  const [ratePodcast] = useRatePodcastMutation();

  const handleRate = async (ratingCount) => {
    await ratePodcast({ podcastId: Number(podcastId), rating: ratingCount });
  };

  const handleStarClick = (starValue) => {
    if (rating) {
      return;
    }
    setRating(starValue);
    handleRate(starValue);
  };

  const stars = Array.from({ length: STARS_COUNT }, (_, index) => {
    const starValue = index + 1;
    const isActive = starValue <= rating;
    const isHover = starValue <= hoverRating && !isActive;

    let starClassName = "";
    if (isActive) {
      starClassName = "active";
    } else if (isHover) {
      starClassName = "hover";
    }

    return {
      starValue,
      starClassName,
    };
  });

  return (
    <RatingWrapper>
      {stars.map(({ starValue, starClassName }) => (
        <RatingStarButton
          key={starValue}
          onClick={() => handleClickWithAuth(handleStarClick)(starValue)}
          onMouseEnter={() => setHoverRating(starValue)}
          onMouseLeave={() => setHoverRating(0)}
        >
          <RatingStar as={Star} className={starClassName} />
        </RatingStarButton>
      ))}
    </RatingWrapper>
  );
};
